import { MY_ORBCON_LABEL } from '../../hooks/useUserSidebar';
import BloodDropIcon from './BloodDropIcon';

export default function MyOrbconLabel({
  className = '',
  iconClassName = 'h-5 w-5',
}: {
  className?: string;
  iconClassName?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <BloodDropIcon className={`flex-shrink-0 text-accent ${iconClassName}`} />
      {MY_ORBCON_LABEL}
    </span>
  );
}
